import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./HomePage.css";
import logoNegativo from "../../assets/ttflow-logo-negativo@3x.png";
import iconeCyan from "../../assets/ttflow-icone-cyan@3x.png";
import iconeAzul from "../../assets/ttflow-icone@2x.png";
import telaCockpit from "../../assets/Tela - light.png";

const FEATURE_LIST = [
  "Recebimento de NFe, CTe e NFSe",
  "Validação fiscal automatizada",
  "Dashboard unificado de status",
  "Armazenamento e trilha de auditoria",
  "Conexão com SEFAZ e Ambiente Nacional",
  "Manifestação do Destinatário automática",
];

const FeaturePinIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2C7.58 2 4 5.58 4 10c0 5.25 6.72 11.44 7.02 11.71a1.5 1.5 0 0 0 1.96 0C13.28 21.44 20 15.25 20 10c0-4.42-3.58-8-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.29-.15-1.72-.85-1.99-.95-.27-.1-.46-.15-.66.15-.2.29-.76.95-.93 1.15-.17.19-.34.22-.63.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.19-.29.29-.49.1-.19.05-.36-.02-.51-.07-.15-.66-1.6-.91-2.19-.24-.58-.48-.5-.66-.51-.17-.01-.36-.01-.56-.01-.19 0-.51.07-.78.36-.27.29-1.02 1-1.02 2.43 0 1.43 1.04 2.82 1.19 3.01.15.19 2.05 3.13 4.96 4.39.69.3 1.23.48 1.65.61.69.22 1.32.19 1.82.11.55-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.27-.19-.56-.34Z" />
    <path d="M12.02 2C6.5 2 2 6.48 2 12c0 1.82.48 3.53 1.32 5.01L2 22l5.13-1.28A9.94 9.94 0 0 0 12.02 22C17.53 22 22 17.52 22 12S17.53 2 12.02 2Zm0 18.1c-1.66 0-3.2-.46-4.53-1.26l-.32-.19-3.04.76.79-2.98-.21-.31A8.07 8.07 0 0 1 3.93 12c0-4.47 3.63-8.1 8.09-8.1 4.46 0 8.08 3.63 8.08 8.1 0 4.47-3.62 8.1-8.08 8.1Z" />
  </svg>
);

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expandedSystem, setExpandedSystem] = useState(null);
  const [screenshotOpen, setScreenshotOpen] = useState(false);

  useEffect(() => {
    const updateHeader = () => setScrolled(window.scrollY > 40);
    updateHeader();
    window.addEventListener("scroll", updateHeader);
    return () => window.removeEventListener("scroll", updateHeader);
  }, []);

  useEffect(() => {
    if (!screenshotOpen) return;
    const handleKeyDown = (e) => { if (e.key === "Escape") setScreenshotOpen(false); };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [screenshotOpen]);

  function toggleSystem(key) {
    setExpandedSystem((prev) => (prev === key ? null : key));
  }

  function handleSystemKeyDown(key, event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleSystem(key);
    }
  }

  return (
    <div className="home-page">
      <header className={scrolled ? "scrolled" : ""}>
        <img src={logoNegativo} alt="TTflow" />

        <nav className="nav-links">
          <a href="#top">Home</a>
          <a href="#sobre">Sobre</a>
          <a href="#sistemas">Sistemas</a>
          <a href="#funcionalidades">Funcionalidades</a>
          <a href="#como-funciona">Como funciona</a>
        </nav>

        <div className="header-actions">
          <Link className="btn btn-nav" to="/portal">Acessar plataforma</Link>
        </div>
      </header>

      <section className="hero" id="top">
        <div className="hero-inner">
          <div className="hero-main">
            <div className="badge">
              <span className="dot"></span>
              <span>SEFAZ conectado &middot; Integração SAP &middot; Mensageria &middot; Inbound</span>
            </div>

            <h1>
              Mensageria e automação
              <br />
              <span className="gradient">Inbound de NFe, CTe e NFSe.</span>
            </h1>

            <p className="subheadline">
              A Mensageria recebe e monitora NFe, CTe e NFSe emitidas por parceiros, com conexão direta à SEFAZ (NFe e CTe) e ao Ambiente
              Nacional (NFSe). O Inbound integra, valida e lança esses documentos no SAP. Dois módulos, uma única plataforma TTflow.
            </p>

            <div className="hero-ctas">
              <Link className="btn btn-primary" to="/portal">Acessar plataforma &rarr;</Link>
              <a className="btn btn-outline" href="#sistemas">Conhecer os sistemas</a>
            </div>
          </div>

          <div className="stats">
            <div className="stat">
              <div className="value">Mensageria</div>
              <div className="label">NF-e / NFS-e / CT-e com integração à SEFAZ e ambiente nacional</div>
            </div>
            <div className="stat">
              <div className="value">Inbound</div>
              <div className="label">Integração, validação e lançamento fiscal automatizado no SAP</div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="sobre">
        <span className="kicker">// Sobre</span>
        <h2 className="section-heading">Um único fluxo para todo o ciclo fiscal eletrônico.</h2>

        <div className="about-grid">
          <div className="about-col">
            <span className="about-accent navy"></span>
            <h3>TTflow</h3>
            <p>
              NFe, CTe e NFSe têm órgãos emissores, ambientes e formatos diferentes — e
              cada um vira um ponto de atenção separado para times fiscais, financeiros e de
              logística que trabalham em SAP. A TTflow reúne recebimento, validação e
              integração desses três documentos em um único portal, para que sua equipe
              pare de tratar cada tipo de nota como um sistema à parte.
            </p>
          </div>
          <div className="about-col">
            <span className="about-accent teal"></span>
            <h3>Escotta</h3>
            <p>
              Somos uma consultoria SAP especializada em automatização de processos.
              Combinamos os melhores talentos e as melhores soluções para tornar nossos clientes cada dia mais eficientes e competitivos.
              Somos a Escotta, a melhor experiência SAP.
            </p>
          </div>
        </div>
      </section>

      <section className="section" id="sistemas">
        <span className="kicker">// Sistemas</span>
        <h2 className="section-heading">Feito para fiscal e logística.</h2>

        <div
          className={`systems-grid${
            expandedSystem === "mensageria" ? " expanded-first" : ""
          }${expandedSystem === "inbound" ? " expanded-second" : ""}`}
        >
          <div
            className={`system-card expandable mensageria${expandedSystem === "mensageria" ? " expanded" : ""}`}
            role="button"
            tabIndex={0}
            aria-expanded={expandedSystem === "mensageria"}
            onClick={() => toggleSystem("mensageria")}
            onKeyDown={(e) => handleSystemKeyDown("mensageria", e)}
          >
            <span className="system-card-toggle">{expandedSystem === "mensageria" ? "−" : "+"}</span>
            <img className="system-icon" src={iconeCyan} alt="" />
            <h3>Mensageria</h3>
            <p>
              Recebimento, armazenamento e
              monitoramento de NFe, CTe e NFSe com
              conexão direta à SEFAZ, ao Ambiente
              Nacional e ao SAP — do documento
              capturado ao status atualizado, em um só
              painel.
            </p>

            <div className={`system-details${expandedSystem === "mensageria" ? " open" : ""}`}>
              <div className="system-details-inner">
                <h4>Mensageria de NFe, CTe e NFSe</h4>
                <p>
                  A Mensageria recebe e centraliza NFe, CTe e NFSe emitidas por fornecedores, prestadores
                  de serviço e transportadoras. A conexão é direta com a SEFAZ (NFe e CTe) e com o
                  Ambiente Nacional (NFSe). Cada documento chega, é capturado, armazenado e monitorado —
                  pronto para ser usado pelas áreas fiscal, financeira e logística, sem digitação manual.
                </p>

                <div className="system-feature-grid">
                  <div className="system-feature">
                    <span className="system-feature-num">01</span>
                    <h5>Captura unificada</h5>
                    <p>Recebe NFe, CTe e NFSe pelo mesmo canal, conectando-se à SEFAZ (NFe e CTe) e ao Ambiente Nacional (NFSe).</p>
                  </div>
                  <div className="system-feature">
                    <span className="system-feature-num">02</span>
                    <h5>Manifestação do Destinatário</h5>
                    <p>Confirma automaticamente ciência, confirmação, desconhecimento ou operação não realizada perante o Fisco, sem intervenção manual.</p>
                  </div>
                  <div className="system-feature">
                    <span className="system-feature-num">03</span>
                    <h5>Coleta contínua</h5>
                    <p>Monitora e captura novos documentos assim que disponibilizados pela SEFAZ ou pelo Ambiente Nacional, sem depender de consultas manuais.</p>
                  </div>
                  <div className="system-feature">
                    <span className="system-feature-num">04</span>
                    <h5>Monitoramento em tempo real</h5>
                    <p>Status de recebimento, manifestação, cancelamento e carta de correção visíveis em um único painel.</p>
                  </div>
                  <div className="system-feature">
                    <span className="system-feature-num">05</span>
                    <h5>Armazenamento e compliance</h5>
                    <p>XML, DANFE, DACTE e RPS organizados e auditáveis, prontos para fiscalização e para a declaração de tributos.</p>
                  </div>
                  <div className="system-feature">
                    <span className="system-feature-num">06</span>
                    <h5>Cobertura nacional</h5>
                    <p>Recebe documentos de qualquer estado (SEFAZ) ou município (Ambiente Nacional), consolidando tudo em um único fluxo.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`system-card expandable inbound${expandedSystem === "inbound" ? " expanded" : ""}`}
            role="button"
            tabIndex={0}
            aria-expanded={expandedSystem === "inbound"}
            onClick={() => toggleSystem("inbound")}
            onKeyDown={(e) => handleSystemKeyDown("inbound", e)}
          >
            <span className="system-card-toggle">{expandedSystem === "inbound" ? "−" : "+"}</span>
            <img className="system-icon" src={iconeAzul} alt="" />
            <h3>Inbound</h3>
            <p>
              Integra, valida e lança automaticamente
              NFe, CTe e NFSe de fornecedores e
              transportadoras no SAP, do recebimento à
              contabilização.
            </p>

            <div className={`system-details${expandedSystem === "inbound" ? " open" : ""}`}>
              <div className="system-details-inner">
                <h4>Automação de NFe, CTe e NFSe Inbound</h4>
                <p>
                  Boa parte da validação fiscal só acontece quando o caminhão já chegou na portaria —
                  e quem recebe a nota nem sempre tem o conhecimento fiscal para decidir se ela deve
                  ou não ser aceita. O Inbound antecipa essa validação para o momento da emissão,
                  centraliza a inteligência fiscal e libera a operação para focar no que importa:
                  conferir quantidade e liberar a carga.
                </p>

                <div className="system-feature-grid cols-2">
                  <div className="system-feature">
                    <span className="system-feature-num">01</span>
                    <h5>Validação antecipada</h5>
                    <p>Inconsistências são identificadas antes mesmo de o fornecedor emitir a nota — e ela pode ser recusada nesse momento.</p>
                  </div>
                  <div className="system-feature">
                    <span className="system-feature-num">02</span>
                    <h5>Leitura unificada</h5>
                    <p>Recebe NFe e CTe da SEFAZ e NFSe do Ambiente Nacional, tratando os três documentos com a mesma lógica de validação e conciliação dentro do SAP.</p>
                  </div>
                  <div className="system-feature">
                    <span className="system-feature-num">03</span>
                    <h5>Controle central</h5>
                    <p>A equipe de recebimento informa apenas a chave de acesso e a quantidade; a análise fiscal fica centralizada.</p>
                  </div>
                  <div className="system-feature">
                    <span className="system-feature-num">04</span>
                    <h5>Redução de erros e riscos</h5>
                    <p>Menos digitação manual significa menos risco de escrituração incorreta e de autuações do Fisco.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="funcionalidades">
        <span className="kicker">// Funcionalidades</span>
        <h2 className="section-heading">Tudo o que cobre o ciclo completo do documento fiscal.</h2>

        <div className="feature-list">
          {FEATURE_LIST.map((label, index) => (
            <div className="feature-row" key={label}>
              <span className={`feature-row-icon-badge ${index % 2 === 0 ? "teal" : "navy"}`}>
                <FeaturePinIcon />
              </span>
              <span className="feature-row-label">{label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="section" id="como-funciona">
        <div className="how-columns">
          <div className="how-info">
            <span className="kicker">// Como funciona</span>
            <h2 className="section-heading">Do documento emitido à contabilização no SAP.</h2>

            <div className="how-steps">
              <div className="how-step">
                <div className="how-step-num">01</div>
                <div>
                  <h3>Emissão pelo parceiro</h3>
                  <p>O fornecedor, prestador de serviço ou transportadora emite a NFe, CTe ou NFSe, que é capturada pela Mensageria via SEFAZ ou Ambiente Nacional.</p>
                </div>
              </div>

              <div className="how-step">
                <div className="how-step-num">02</div>
                <div>
                  <h3>Validação</h3>
                  <p>Regras fiscais e de negócio são checadas contra o pedido e o cadastro no SAP antes da liberação.</p>
                </div>
              </div>

              <div className="how-step">
                <div className="how-step-num">03</div>
                <div>
                  <h3>Padronização</h3>
                  <p>Leiaute único aplicado aos documentos vindos da SEFAZ (NFe, CTe) e do Ambiente Nacional (NFSe), independentemente da origem.</p>
                </div>
              </div>

              <div className="how-step">
                <div className="how-step-num">04</div>
                <div>
                  <h3>Integração SAP</h3>
                  <p>O dado processado alimenta o SAP para escrituração, contabilização e liberação do fluxo.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="how-mock">
            <div className="mock-window">
              <div className="mock-titlebar">
                <span className="dot red"></span>
                <span className="dot yellow"></span>
                <span className="dot green"></span>
                <span className="mock-title">inbound.escotta.app &mdash; cockpit</span>
              </div>
              <div className="mock-body">
                <button
                  type="button"
                  className="mock-screenshot-btn"
                  onClick={() => setScreenshotOpen(true)}
                  aria-label="Ampliar imagem do cockpit"
                >
                  <img className="mock-screenshot" src={telaCockpit} alt="Painel de documentos fiscais do cockpit Escotta Inbound Automation" />
                  <span className="mock-screenshot-hint">&#128269; Clique para ampliar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {screenshotOpen && (
        <div className="screenshot-lightbox" onClick={() => setScreenshotOpen(false)}>
          <button
            type="button"
            className="screenshot-lightbox-close"
            onClick={() => setScreenshotOpen(false)}
            aria-label="Fechar"
          >
            &#10005;
          </button>
          <img
            className="screenshot-lightbox-img"
            src={telaCockpit}
            alt="Painel de documentos fiscais do cockpit Escotta Inbound Automation, em tamanho ampliado"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <section className="section">
        <div className="cta-card">
          <span className="kicker">// Contato</span>
          <h2 className="cta-heading">
            Pronto para simplificar sua mensageria e seu recebimento fiscal?
          </h2>
          <p className="cta-sub">
            Fale com um especialista e veja como a Mensageria e o Inbound da TTflow se encaixam
            no seu ambiente SAP.
          </p>
          <a
            className="btn btn-primary"
            href="https://wa.me/554130230444"
            target="_blank"
            rel="noopener noreferrer"
          >
            Falar no WhatsApp &rarr;
          </a>
        </div>
      </section>

      <footer className="site-footer">
        <div className="footer-top">
          <div className="footer-brand">
            <img src={logoNegativo} alt="TTflow" />
            <p>
              NFe, CTe e NFSe em um único portal. Recebimento, validação e integração para times fiscais, financeiros e de logística no SAP.
            </p>
            <div className="footer-badges">
              <span>SEFAZ</span>
              <span>NF-e</span>
              <span>NFS-e</span>
              <span>Inbound</span>
            </div>

            <div className="footer-social">
              <a href="https://www.instagram.com/escotta_consulting/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24"><path d="M12 2c2.72 0 3.06.01 4.12.06 1.06.05 1.79.22 2.43.47.66.26 1.22.6 1.77 1.15.55.55.9 1.11 1.15 1.77.25.64.42 1.37.47 2.43.05 1.06.06 1.4.06 4.12s-.01 3.06-.06 4.12c-.05 1.06-.22 1.79-.47 2.43a4.9 4.9 0 0 1-1.15 1.77 4.9 4.9 0 0 1-1.77 1.15c-.64.25-1.37.42-2.43.47-1.06.05-1.4.06-4.12.06s-3.06-.01-4.12-.06c-1.06-.05-1.79-.22-2.43-.47a4.9 4.9 0 0 1-1.77-1.15 4.9 4.9 0 0 1-1.15-1.77c-.25-.64-.42-1.37-.47-2.43C2.01 15.06 2 14.72 2 12s.01-3.06.06-4.12c.05-1.06.22-1.79.47-2.43.26-.66.6-1.22 1.15-1.77A4.9 4.9 0 0 1 5.45 2.53c.64-.25 1.37-.42 2.43-.47C8.94 2.01 9.28 2 12 2Zm0 1.8c-2.67 0-2.99.01-4.04.06-.87.04-1.34.18-1.65.3-.42.16-.72.36-1.03.67-.31.31-.51.61-.67 1.03-.12.31-.26.78-.3 1.65C4.26 8.51 4.25 8.83 4.25 12s.01 3.49.06 4.54c.04.87.18 1.34.3 1.65.16.42.36.72.67 1.03.31.31.61.51 1.03.67.31.12.78.26 1.65.3 1.05.05 1.37.06 4.04.06s2.99-.01 4.04-.06c.87-.04 1.34-.18 1.65-.3.42-.16.72-.36 1.03-.67.31-.31.51-.61.67-1.03.12-.31.26-.78.3-1.65.05-1.05.06-1.37.06-4.54s-.01-3.49-.06-4.54c-.04-.87-.18-1.34-.3-1.65a2.77 2.77 0 0 0-.67-1.03 2.77 2.77 0 0 0-1.03-.67c-.31-.12-.78-.26-1.65-.3C14.99 3.81 14.67 3.8 12 3.8Zm0 3.05a5.15 5.15 0 1 1 0 10.3 5.15 5.15 0 0 1 0-10.3Zm0 1.8a3.35 3.35 0 1 0 0 6.7 3.35 3.35 0 0 0 0-6.7Zm5.34-1.98a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z"/></svg>
              </a>
              <a href="https://www.facebook.com/escotta" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24"><path d="M13.5 21v-7.6h2.55l.38-2.96h-2.93V8.56c0-.86.24-1.44 1.47-1.44h1.57V4.47C16.24 4.4 15.32 4.3 14.24 4.3c-2.24 0-3.78 1.37-3.78 3.87v2.16H7.9v2.96h2.56V21h3.04Z"/></svg>
              </a>
              <a href="http://linkedin.com/company/escotta/posts/?feedView=all" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24"><path d="M6.94 8.5H3.56V20.4h3.38V8.5ZM5.25 3.1a1.96 1.96 0 1 0 0 3.92 1.96 1.96 0 0 0 0-3.92ZM20.44 20.4v-6.53c0-3.5-1.87-5.13-4.36-5.13-2.01 0-2.91 1.1-3.41 1.88V8.5H9.29c.04.96 0 11.9 0 11.9h3.38v-6.65c0-.36.03-.71.13-.97.29-.71.94-1.45 2.04-1.45 1.44 0 2.02 1.1 2.02 2.7v6.37h3.58Z"/></svg>
              </a>
              <a href="https://www.youtube.com/c/Escotta" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24"><path d="M22 12s0-3.15-.4-4.66a2.79 2.79 0 0 0-1.96-1.98C18.02 5 12 5 12 5s-6.02 0-7.64.36a2.79 2.79 0 0 0-1.96 1.98C2 8.85 2 12 2 12s0 3.15.4 4.66c.22.82.98 1.5 1.96 1.72C6.02 19 12 19 12 19s6.02 0 7.64-.62a2.79 2.79 0 0 0 1.96-1.72C22 15.15 22 12 22 12ZM10 15.5v-7l6 3.5-6 3.5Z"/></svg>
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Produto</h4>
            <a href="#funcionalidades">Funcionalidades</a>
            <a href="#sistemas">Sistemas</a>
            <a href="#como-funciona">Como funciona</a>
          </div>

          <div className="footer-col">
            <h4>Empresa</h4>
            <a href="#sobre">Sobre</a>
          </div>

          <div className="footer-col">
            <h4>Legal</h4>
            <Link to="/termos">Termos de Uso e Privacidade</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <span>&copy; 2026 Escotta &middot; TTflow</span>
        </div>
      </footer>

      <a
        className="whatsapp-float"
        href="https://wa.me/554130230444"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Fale conosco no WhatsApp"
      >
        <WhatsAppIcon />
      </a>
    </div>
  );
};

export default HomePage;
